import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from "react-select";
import Preloader from '../../../general/Preloader';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import 'sweetalert2/dist/sweetalert2.min.css'; // Importar los estilos de SweetAlert2

const FormUpdate = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [data, setData] = useState([]);
    const [selectedOptionCountry, setSelectedOptionCountry] = useState();
    const [selectedOptionCity, setSelectedOptionCity] = useState();
    const [selectedOptionDocumentType, setSelectedOptionDocumentType] = useState();
    const [selectedOptionCurrency, setSelectedOptionCurrency] = useState();
    const [isLoaded, setIsLoaded] = useState(true);
    const [form, setForm] = useState({
        name: "",
        lastname: "",
        type_account: "",
        business_name: "",
        address: "",
        nit: "",
        type_entity: "",
        account_number: "",
        account_number_confirm: "",
        swiftcode: "",
        beneficiary_name: "",
        country_id: "",
        city_id: "",
        currency_id: "",
        document_type_id: "",
        email: ""
    });


    const updateRegister = (register) => {
        setSelectedOptionCountry(register.country)
        setSelectedOptionCity(register.city)
        setSelectedOptionDocumentType(register.document_type)
        setSelectedOptionCurrency(register.currency)

        setForm({
            name: register.name,
            lastname: register.lastname,
            type_account: register.type_account,
            business_name: register.business_name,
            address: register.address,
            nit: register.nit,
            type_entity: register.type_entity,
            account_number: register.account_number,
            account_number_confirm: register.account_number_confirm,
            swiftcode: register.swiftcode, 
            email: register.email,
            beneficiary_name: register.beneficiary_name,
            country_id: register.country.value,
            city_id: register.city.value,
            currency_id: register.currency.value,
            document_type_id: register.document_type.value
        })
    }

    const handleSubmit = e => {
        e.preventDefault();
    };

    const messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            icon: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fetch(`/api/v1/get_payment_info/${props.user.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            updateRegister(data.register);
            setIsLoaded(false);
        });
    }

    const handleClickUpdate = () => {
        setIsLoaded(true);
        fetch(`/api/v1/payment_infos/${props.user.payment_info.id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(form), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            if(data.type == "success"){
                props.toggle();
                setIsLoaded(false);
                messageSuccess(data);
                updateRegister(data.register);
            }
        });
    }

    const handleChangeAutocompleteCountry = (selectedOptionCountry) => {
        setSelectedOptionCountry(selectedOptionCountry);
        setForm({ ...form, ["country_id"]: selectedOptionCountry.value })
    }

    const handleChangeAutocompleteCity = (selectedOptionCity) => {
        setSelectedOptionCity(selectedOptionCity);
        setForm({ ...form, ["city_id"]: selectedOptionCity.value })
    }

    const handleChangeAutocompleteDocumentType = (selectedOptionDocumentType) => {
        setSelectedOptionDocumentType(selectedOptionDocumentType);
        setForm({ ...form, ["document_type_id"]: selectedOptionDocumentType.value })
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered" backdrop={props.backdrop}>
                {/*<ModalHeader toggle={props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {props.title}</ModalHeader>*/}

                    <form onSubmit={handleSubmit}>
                        <ModalBody>
                            <div className="row">      
                                {!isLoaded ? (
                                    <React.Fragment>
                                        <div className="col-md-6">
                                            <label className='text-primary'>Pais</label>
                                            <input
                                                type="hidden"
                                                name="value"
                                                value={selectedOptionCountry.value}
                                            />
                                            <Select
                                                onChange={handleChangeAutocompleteCountry}
                                                options={props.countries}
                                                autoFocus={false}
                                                className={`link-form`}
                                                value={selectedOptionCountry}
                                                isDisabled={isLoaded}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className='text-primary'>Tipo de entidad *</label>
                                            <select
                                                className='form form-control'
                                                name='type_entity'
                                                value={form.type_entity}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                            >
                                                <option value="">Seleccione una opcion</option>
                                                <option value="sole_prop"> Empresario Individual (Autónomo) </option>
                                                <option value="non_profit"> Sin fines de lucro </option>
                                                <option value="corporation"> Sociedad Anónima (SA) </option>
                                                <option value="partnership"> Sociedad Colectiva </option>
                                                <option value="llc"> Sociedad de Responsabilidad Limitada (SL, SRL, SRLE) </option>
                                            </select>
                                        </div>

                                        <div className="col-md-12">
                                            <hr />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Tipo de documento</label>
                                            <input
                                                type="hidden"
                                                name="value"
                                                value={selectedOptionDocumentType.value}
                                            />
                                            <Select
                                                onChange={handleChangeAutocompleteDocumentType}
                                                options={props.document_types}
                                                autoFocus={false}
                                                className={`link-form`}
                                                value={selectedOptionDocumentType} 
                                                isDisabled={isLoaded}
                                            />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Número</label>
                                            <input 
                                                type="text" 
                                                name="nit"
                                                value={form.nit}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <hr />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Nombre</label>
                                            <input 
                                                type="text" 
                                                name="name"
                                                value={form.name}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-6 mt-3">
                                            <label className='text-primary'>Apellido</label>
                                            <input 
                                                type="text" 
                                                name="name"
                                                value={form.lastname}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <hr />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Razón social</label>
                                            <input 
                                                type="text" 
                                                name='business_name'
                                                value={form.business_name}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Email</label>
                                            <input 
                                                type="text" 
                                                name='email'
                                                value={form.email}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <hr />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Dirección</label>
                                            <input 
                                                type="text" 
                                                name="address"
                                                value={form.address}
                                                onChange={handleChange}
                                                disabled={isLoaded}
                                                className='form form-control'
                                            />
                                        </div>

                                        <div className="col-md-6 mt-3 mb-3">
                                            <label className='text-primary'>Ciudad</label>
                                            <input
                                                type="hidden"
                                                name="value"
                                                value={selectedOptionCity.value}
                                            />
                                            <Select
                                                onChange={handleChangeAutocompleteCity}
                                                options={props.cities}
                                                autoFocus={false}
                                                className={`link-form`}
                                                value={selectedOptionCity}
                                                isDisabled={isLoaded}
                                            />
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <div className="text-center">
                                        <Preloader/>
                                    </div>
                                )}
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light" onClick={() => props.toggle()}>Cerrar</label>
                            <button className="btn btn-primary" disabled={isLoaded} onClick={() => handleClickUpdate()}>{isLoaded ? "Cargando..." : props.nameBnt}</button>
                        </ModalFooter>
                    </form>
            </Modal>
        </React.Fragment>
    );
}


export default FormUpdate;

